import React from "react";
import "../App.css";

const AboutPage = () => {
  return (
    <div className="about-main">
      <div className="about-container">
        <div className="about-image">
          <img src="/site-images/site-image-7.png" alt="Team at work" />
        </div>
        <div className="about-content">
          <h1 className="section-title">Who We Are</h1>
          <p>
            Hacky Apps started as a side project between friends who love
            building things that work. We’re based in New York, and we care
            about making tech that’s actually useful for real people.
          </p>
          <p>
            We’ve helped local shops, startups, and nonprofits launch apps and
            websites that fit their needs and budget. We’re not a big agency,
            just a small team that listens, builds, and supports you every step
            of the way.
          </p>
          <ul className="about-list">
            <li>Custom web & app builds (no cookie-cutter stuff)</li>
            <li>Design that matches your vibe</li>
            <li>Advice you can actually use</li>
            <li>Clear communication, always</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
